/** Google's mark, inlined because the icon set the app uses ships no brand logos */
const GoogleIcon = ({size = 20}: { size?: number }) => (
    <svg width={size} height={size} viewBox={"0 0 48 48"} aria-hidden={"true"}>
        <path fill={"#EA4335"}
              d={"M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.2C12.4 13.7 17.7 9.5 24 9.5z"}/>
        <path fill={"#4285F4"}
              d={"M46.98 24.55c0-1.6-.15-3.15-.42-4.64H24v9.02h12.94c-.56 2.9-2.23 5.36-4.75 7.02l7.66 5.95c4.48-4.14 7.13-10.24 7.13-17.35z"}/>
        <path fill={"#FBBC05"}
              d={"M10.49 28.6A14.4 14.4 0 0 1 9.73 24c0-1.6.28-3.15.76-4.6l-7.9-6.2A24 24 0 0 0 0 24c0 3.87.93 7.52 2.6 10.8l7.89-6.2z"}/>
        <path fill={"#34A853"}
              d={"M24 48c6.48 0 11.93-2.13 15.9-5.81l-7.66-5.95c-2.13 1.44-4.88 2.3-8.24 2.3-6.3 0-11.6-4.22-13.51-9.94l-7.9 6.2C6.47 42.62 14.6 48 24 48z"}/>
    </svg>
)

export default GoogleIcon
